import { useCurrentUser } from "web/hooks/data"
import { useCurrentView } from "web/components"

import Layout from "./Layout"
import TableLayout from "./TableLayout"

export default function ListTasks(props) {
  const currentView = useCurrentView()
  const currentUser = useCurrentUser()

  return (
    <>
      <Layout user={currentUser} {...currentView}>
        <TableLayout
          fetchURL={props.fetchURL}
          user={currentUser}
          {...currentView}
        />
      </Layout>
    </>
  )
}
